// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Location',
  all_one: 'All {{count}} locations',
  all_other: 'All {{count}} locations',
};
